import { ADMIN_SEG, countAdminSeguimientoUnreadFromQuery, fetchAdminSeguimientoReadIds, markAdminSeguimientoRead, markAdminSeguimientoUnread, markAllAdminSeguimientoRead } from './adminSeguimientoLecturas.js';
import { supabase } from './supabase.js';

const SECTION = ADMIN_SEG.NOTICIAS_BORRADOR;

/** @deprecated Usar adminSeguimientoLecturas; mantenido por compatibilidad. */
export async function fetchNoticiasAdminReadIds(adminId, noticiaIds = []) {
  return fetchAdminSeguimientoReadIds(adminId, SECTION, noticiaIds);
}

export async function countNoticiasBorradoresSinLeer(adminId) {
  return countAdminSeguimientoUnreadFromQuery(adminId, SECTION, () =>
    supabase.from('noticias_musica').select('id').eq('publicado', false)
  );
}

export async function markNoticiaAdminRead(adminId, noticiaId) {
  return markAdminSeguimientoRead(adminId, SECTION, noticiaId);
}

export async function markNoticiaAdminUnread(adminId, noticiaId) {
  return markAdminSeguimientoUnread(adminId, SECTION, noticiaId);
}

export async function markAllNoticiasBorradoresRead(adminId) {
  const { data: borradores, error: loadErr } = await supabase
    .from('noticias_musica')
    .select('id')
    .eq('publicado', false);
  if (loadErr) return { error: loadErr };
  const ids = (borradores ?? []).map(b => b.id).filter(Boolean);
  return markAllAdminSeguimientoRead(adminId, SECTION, ids);
}
